import React from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";
import _ from "lodash";

import useFiringActions from "../hooks/useFiringActions";
import Modal from "../Modal";
import useFirebaseSegments from "../hooks/useFirebaseSegments";
import useFirebaseFiring from "../hooks/useFirebaseFiring";

const FiringDeletePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const firing = useFirebaseFiring(id!);
  const segments = useFirebaseSegments();
  const { deleteFiring } = useFiringActions();

  const my_segments = _.filter(
    segments,
    (segment) => segment && segment.firing_id === id
  );

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        disabled={my_segments.length !== 0}
        onClick={() => {
          if (my_segments.length === 0) {
            deleteFiring(id!);
          }
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!firing || !segments) {
      return <div>Loading...</div>;
    }
    if (my_segments.length !== 0) {
      return (
        <div>
          This firing still has some segments. You can't delete the firing without first deleting
          every segment.
        </div>
      );
    }

    return (
      <React.Fragment>
        <div>Name:{firing.name}</div>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Firing"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default FiringDeletePage;
